import React from "react";
import { useState, useEffect } from "react";
import videoCover from "../assets/img/videoCover.png";
function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}
export default function VideoBg(props) {
  const { height, width } = useWindowDimensions();
  return (
    <video
      playsInline
      autoPlay
      muted
      loop
      poster={videoCover}
      id="bgvid"
      style={{
        position: "absolute",
        width: width,
        height: height,
        zIndex: 0,
        objectFit: "cover",
      }}
    >
      <source
        src="https://firebasestorage.googleapis.com/v0/b/bodrumcab.firebasestorage.app/o/vito.mp4?alt=media&token=28967797-89fe-49ea-b69b-849275c88907"
        type="video/mp4"
      />
    </video>
  );
}
